import PATHS from '~/constants/paths';

export const FLOWGO_PATH = PATHS.flowGo;

export default {
  menu: 'menu',
  studio: 'studio',
  classroom: 'classroom',
  tutorial: 'tutorial',
  noLoad: 'noLoad',
  ending: 'ending',
  production: 'production',
  arcade: 'arcade',
};
